var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.025 2.75C2.8282 2.75 2.75 2.88813 2.75 2.96154V13.5385C2.75 13.6119 2.8282 13.75 3.025 13.75H8.9375V15.125H3.025C2.15865 15.125 1.375 14.4581 1.375 13.5385V2.96154C1.375 2.0419 2.15865 1.375 3.025 1.375H8.8C8.97421 1.375 9.14196 1.44115 9.26929 1.56008L12.1568 4.2572C12.296 4.38721 12.375 4.56915 12.375 4.75962V6.1875H11V5.44712H8.8C8.42029 5.44712 8.1125 5.13931 8.1125 4.75962V2.75H3.025Z",
    fill: "#007085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.275 6.875C10.4087 6.875 9.625 7.54188 9.625 8.46154V19.0385C9.625 19.9581 10.4087 20.625 11.275 20.625H18.975C19.8413 20.625 20.625 19.9581 20.625 19.0385V10.2596C20.625 10.0691 20.546 9.88721 20.4068 9.75721L17.5193 7.06008C17.392 6.94114 17.2242 6.875 17.05 6.875H11.275ZM11 8.46154C11 8.38812 11.0782 8.25 11.275 8.25H16.3625V10.2596C16.3625 10.6393 16.6703 10.9471 17.05 10.9471H19.25V19.0385C19.25 19.1119 19.1718 19.25 18.975 19.25H11.275C11.0782 19.25 11 19.1119 11 19.0385V8.46154Z",
    fill: "#007085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.c13798b1e2bb8d787312c6ae688add7e.svg";
export { ForwardRef as ReactComponent };